import {useLocation, useParams} from "react-router-dom";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../Constants";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {Button, Typography} from "@mui/material";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import ModuleController from "../../../API/organization/ModuleController";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import {SideBaseModule} from "../../../data/SideBaseModule";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import {replaceEmptyStringsOnNull} from "../../../utils/ReplaceEmptyStringsOnNull";
import {PatternsTableFilterData} from "../../../data/FilterTables/PatternsTableFilterData";
import PatternsTable from "./PatternsTable";
import CircularProgress from "@mui/material/CircularProgress";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import DetailTable from "../../../components/UI/table/cutting/details/DetailTable";
import {DetailFilterData} from "../../../data/FilterTables/DetailFilterData";
import DetailCompositionController from "../../../API/organization/DetailCompositionController";
import FittingsTable from "./FittingsTable";
import {FittingsFilterData} from "../../../data/FilterTables/FittingsFilterData";
import ModulesTable from "./ModulesTable";
import VariablesTable from "../../../components/UI/table/customer-detales/processing/VariablesTable";
import {VariablesFilterData} from "../../../data/FilterTables/VariablesFilterData";
import {ModulesFilterData} from "../../../data/FilterTables/ModulesFilterData";
import {HeightLocationModule} from "../../../data/HeightLocationModule";
import DependentModuleCompositionsTable from "./DependentModuleCompositionsTable";
import Module3DView from "./Module3DView";
import {getDependModuleKey, moduleDimensionsChanged} from "./module3d/embeddedModuleScene";
import {normalizeVariablesTableRows} from "../../../utils/compositionVariables";
import {stampCompositionDetailList} from "./module3d/pacedDetailModule";
import {asArray} from "../../../utils/asArray";
import {pickKitchenCompositionId} from "../../../utils/withCompositionIdQuery";
import PacedModulePlacementPanel from "./PacedModulePlacementPanel";

const PACED_MODULE_TAB = 9;

const initValidation = {
    "name": "", "width": "",
    "height": "",
    "depth": "",
    "minWidth": "",
    "minHeight": "",
    "minDepth": "",
    "maxWidth": "",
    "maxHeight": "",
    "maxDepth": ""
}
const ModulesItem = () => {
    const ComponentDetailWithFilter = useMemo(() => {
        return withFilter(DetailTable, DetailFilterData);
    }, []);
    const ComponentPatternsWithFilter = useMemo(() => {
        return withFilter(PatternsTable, PatternsTableFilterData);
    }, []);
    const ComponentFittingsWithFilter = useMemo(() => {
        return withFilter(FittingsTable, FittingsFilterData);
    }, []);
    const ComponentVariablesWithFilter = useMemo(() => {
        return withFilter(VariablesTable, VariablesFilterData);
    }, []);
    const ComponentModulesWithFilter = useMemo(() => {
        return withFilter(ModulesTable, ModulesFilterData);
    }, []);
    const sideBaseModuleList = Object.entries(SideBaseModule)
    const heightLocationModuleList = Object.entries(HeightLocationModule)
    const params = useParams();
    const pathname = useLocation().pathname
    // Ключ вкладки привязываем к id модуля, а не к полному pathname
    // (иначе /module/:id и /module/:id/depend/... хранят tab отдельно).
    const tabStoragePath = `/organization/module/${params.id}`
    const [loading, setLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const [data, setData] = useState({
        "id": null,
        "name": "",
        "groupName": "",
        "sideBaseModule": sideBaseModuleList[0][0],
        "heightLocation": heightLocationModuleList[0][0],
        "width": null,
        "height": null,
        "depth": null,
        "minWidth": null,
        "minHeight": null,
        "minDepth": null,
        "maxWidth": null,
        "maxHeight": null,
        "maxDepth": null,
        "patternW": null,
        "patternD": null,
        "patternH": null,
    });
    const [details, setDetails] = useState([])
    const [detailsLoading, setDetailsLoading] = useState(true)
    const [validationState, setValidationState] = useState(initValidation)
    const [moduleName, setModuleName] = useState("")
    const [patterns, setPatterns] = useState([])
    const [variables, setVariables] = useState([])
    const [dependentModuleCompositions, setDependentModuleCompositions] = useState([])
    const [embeddedSceneRefreshKey, setEmbeddedSceneRefreshKey] = useState(0)
    const [alertData, setAlertData] = useState({});
    const [tab, setTab] = useState(() => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const savedTab = pagesData[tabStoragePath]?.tab ?? pagesData[pathname]?.tab
        return Number(savedTab) >= 1 ? Number(savedTab) : 1
    });
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        if (typeof nextState === "function") {
            setTableOptions((prev) => {
                const resolved = nextState(prev)
                if (resolved?.pageSize != null && resolved.pageSize !== prev.pageSize) {
                    EditLocalStoragePagesData(tabStoragePath, "pageSize", resolved.pageSize)
                }
                return resolved
            })
            return
        }
        setTableOptions(nextState)
        if (nextState?.pageSize != null && nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(tabStoragePath, "pageSize", nextState.pageSize)
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const savedTab = pagesData[tabStoragePath]?.tab ?? pagesData[pathname]?.tab ?? 1

        return {savedTab: Number(savedTab) >= 1 ? Number(savedTab) : 1}
    }

    useEffect(() => {
        const {savedTab} = getStartPageSize()
        setTab(savedTab)
        setDetails([])
        setDetailsLoading(true)
        setIsLoading(true)

        const moduleId = params.id
        if (moduleId == null || moduleId === "") {
            setIsLoading(false)
            setDetailsLoading(false)
            return undefined
        }

        let cancelled = false

        DetailCompositionController.byModuleId(moduleId)
            .then(function (response) {
                if (cancelled) return
                const stamped = stampCompositionDetailList(response.data)
                setDetails(stamped)
                tableOptionsHandle((prev) => ({
                    ...prev,
                    totalElements: asArray(stamped).length,
                }))
            })
            .catch(function (error) {
                if (!cancelled) handleModalAlert(error)
            })
            .finally(() => {
                if (!cancelled) setDetailsLoading(false)
            })

        ModuleController.getById(moduleId).then(function (response) {
            if (cancelled) return
            const {
                detailPatterns,
                variablesMap,
                relateDetails,
                dependentModuleCompositions: dependentModules,
                ...rest
            } = response.data
            setData({
                ...rest,
                dependModules: asArray(rest.dependModules),
                fittings: asArray(rest.fittings),
            })
            setModuleName(rest.name)
            setPatterns(asArray(detailPatterns))
            setVariables(normalizeVariablesTableRows(variablesMap))
            setDependentModuleCompositions(asArray(dependentModules))
            setTab(savedTab)
            if (savedTab === 2 || savedTab === 4) {
                tableOptionsHandle((prev) => ({
                    ...prev,
                    totalElements: savedTab === 2
                        ? asArray(detailPatterns).length
                        : asArray(rest.fittings).length,
                }))
            }
        })
            .catch(function (error) {
                if (!cancelled) handleModalAlert(error)
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false)
            })

        return () => {
            cancelled = true
        }
    }, [params.id]);

    const setDetailsFromTable = (updater) => {
        setDetails((prev) => {
            const next = typeof updater === "function" ? updater(prev) : updater;
            return stampCompositionDetailList(next, prev);
        });
    };

    const setPacedDetailModuleByKey = (detailKey, pacedDetailModule) => {
        setDetailsFromTable((prev) => prev.map((detail) => {
            const key = detail?.compositionDetailId ?? detail?.id ?? detail?.position ?? detail?.name;
            if (String(key) !== String(detailKey)) return detail;
            return {
                ...detail,
                pacedDetailModule: pacedDetailModule ?? null,
            };
        }));
    };

    const setPacedDependModuleByKey = (moduleKey, pacedModule) => {
        setDependModules((prev) => prev.map((row, index) => {
            const key = getDependModuleKey(row, index);
            if (String(key) !== String(moduleKey)) return row;
            return {
                ...row,
                pacedModule: pacedModule ?? null,
            };
        }));
    };

    const handleChangeTab = (nextTab) => {
        // Сначала пишем tab: если localStorage почти заполнен данными 3D,
        // падение на pageSize не должно мешать сохранить активную вкладку.
        EditLocalStoragePagesData(tabStoragePath, "tab", nextTab)
        setTab(nextTab)
        tableOptionsHandle((prev) => ({
            ...prev,
            totalElements: nextTab === 2
                ? asArray(patterns).length
                : nextTab === 4
                    ? asArray(data.dependModules).length
                    : nextTab === 5
                        ? asArray(data.fittings).length
                        : nextTab === 7
                            ? asArray(dependentModuleCompositions).length
                            : asArray(details).length
        }))
    }

    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleUpdate = () => {
        setLoading(true)
        const {
            id,
            fittings,
            dependModules,
            variablesMap,
            relateDetails,
            module,
            coordinateXPoint,
            coordinateYPoint,
            priority,
            dependentModuleComposition,
            dependentModuleCompositions,
            originalModuleComposition,
            pacedModule,
            ...value
        } = data
        ModuleController.update(replaceEmptyStringsOnNull(value), id)
            .then(async function (response) {
                const prevDims = {
                    width: data.width,
                    height: data.height,
                    depth: data.depth,
                };
                setData({...data, ...response.data})
                setModuleName(response.data.name)
                setDetailsLoading(true)
                const detailsResponse = await DetailCompositionController.byModuleId(id)
                setDetails((prev) => stampCompositionDetailList(detailsResponse.data, prev))
                if (moduleDimensionsChanged(prevDims, response.data)) {
                    setEmbeddedSceneRefreshKey((key) => key + 1);
                }
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => {
                setLoading(false)
                setDetailsLoading(false)
            })
    }
    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(data).forEach(([name, value]) => {

            if (value === "" && name !== "groupName") {
                newErrors[name] = "пустое поле"
            }
        })

        setValidationState(newErrors)

        if (Object.values(newErrors).every(el => el === "")) {
            handleUpdate()
        }
    }
    const setFittings = (newData) => {
        setData(prev => ({...prev, fittings: newData}))
    }
    const setDependModules = (newData) => {
        setData(prev => ({
            ...prev,
            dependModules: typeof newData === "function"
                ? newData(asArray(prev.dependModules))
                : newData,
        }))
    }
    const setPacedModule = (nextPacedModule) => {
        setData((prev) => ({...prev, pacedModule: nextPacedModule}))
    }
    const tabBarRef = useRef(null)
    const [tabBarWidth, setTabBarWidth] = useState(null)

    useEffect(() => {
        const tabBarElement = tabBarRef.current
        if (!tabBarElement) {
            return undefined
        }

        const updateTabBarWidth = () => {
            setTabBarWidth(Math.round(tabBarElement.getBoundingClientRect().width))
        }

        updateTabBarWidth()
        const resizeObserver = new ResizeObserver(updateTabBarWidth)
        resizeObserver.observe(tabBarElement)
        window.addEventListener('resize', updateTabBarWidth)

        return () => {
            resizeObserver.disconnect()
            window.removeEventListener('resize', updateTabBarWidth)
        }
    }, [])

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Модуль ${moduleName}`}
                path={params.parentId ? [{name: "Главная", href: "/"}, {
                    name: "Настройки",
                    href: "/settings"
                }, {
                    name: `Модуль ${params.parentName}`,
                    href: `/organization/module/${params.parentId}`
                }] : [{name: "Главная", href: "/"}, {name: "Настройки", href: "/settings"}]}/>
            <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                <Typography sx={{fontSize: "24px", fontWeight: 700}}>{`Модуль ${moduleName}`}</Typography>
                <ButtonGroupTabBar ref={tabBarRef} activeTab={tab}>
                    <Button tabIndex={1} onClick={() => handleChangeTab(1)}>
                        <CheckIcon/>
                        Основные
                    </Button>
                    <Button tabIndex={2} onClick={() => handleChangeTab(2)}>
                        <CheckIcon/>
                        Паттерны
                    </Button>
                    <Button tabIndex={3} onClick={() => handleChangeTab(3)}>
                        <CheckIcon/>
                        Детали
                    </Button>
                    <Button tabIndex={4} onClick={() => handleChangeTab(4)}>
                        <CheckIcon/>
                        Встраиваемые модули
                    </Button>
                    <Button tabIndex={5} onClick={() => handleChangeTab(5)}>
                        <CheckIcon/>
                        Фурнитура
                    </Button>
                    <Button tabIndex={6} onClick={() => handleChangeTab(6)}>
                        <CheckIcon/>
                        Переменные
                    </Button>
                    <Button tabIndex={7} onClick={() => handleChangeTab(7)}>
                        <CheckIcon/>
                        Связи
                    </Button>
                    <Button tabIndex={8} onClick={() => handleChangeTab(8)}>
                        <CheckIcon/>
                        3D
                    </Button>
                    <Button tabIndex={PACED_MODULE_TAB} onClick={() => handleChangeTab(PACED_MODULE_TAB)}>
                        <CheckIcon/>
                        Размещение
                    </Button>
                </ButtonGroupTabBar>
                {isLoading ?
                    <Box sx={{
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CircularProgress disableShrink/>
                    </Box> : <>
                        {tab === 1 ? <Box sx={{display: "flex", gap: "20px"}}>
                            <Box sx={{width: "400px"}}>
                                <TextFieldValidation
                                    name={"name"}
                                    type={"text"}
                                    value={data?.name}
                                    label={"Наименование"}
                                    setCurrValues={setData}
                                    validationError={validationState?.name}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"groupName"}
                                    type={"text"}
                                    value={data?.groupName}
                                    label={"Группа"}
                                    setCurrValues={setData}
                                    required={false}
                                />

                                <TextFieldValidation
                                    select
                                    label="Расположение"
                                    value={data?.sideBaseModule}
                                    setCurrValues={(getData) => setData(prev => ({
                                        ...prev,
                                        sideBaseModule: getData()
                                    }))}
                                    width={"400px"}
                                    required={false}
                                >
                                    {sideBaseModuleList?.map((option) => (
                                        <MenuItem key={option[0]} value={option[0]}>
                                            {option[1]}
                                        </MenuItem>
                                    ))}
                                </TextFieldValidation>
                                <TextFieldValidation
                                    select
                                    label="Расположение по высоте"
                                    value={data?.heightLocation}
                                    setCurrValues={(getData) => setData(prev => ({
                                        ...prev,
                                        heightLocation: getData()
                                    }))}
                                    width={"400px"}
                                    required={false}
                                >
                                    {heightLocationModuleList?.map((option) => (
                                        <MenuItem key={option[0]} value={option[0]}>
                                            {option[1]}
                                        </MenuItem>
                                    ))}
                                </TextFieldValidation>
                                <TextFieldValidation
                                    name={"width"}
                                    type={"number"}
                                    value={data?.width}
                                    label={"Ширина"}
                                    setCurrValues={setData}
                                    validationError={validationState?.width}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"height"}
                                    type={"number"}
                                    value={data?.height}
                                    label={"Высота"}
                                    setCurrValues={setData}
                                    validationError={validationState?.height}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"depth"}
                                    type={"number"}
                                    value={data?.depth}
                                    label={"Глубина"}
                                    setCurrValues={setData}
                                    validationError={validationState?.depth}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"minWidth"}
                                    type={"number"}
                                    value={data?.minWidth}
                                    label={"Минимальная ширина"}
                                    setCurrValues={setData}
                                    validationError={validationState?.minWidth}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"minHeight"}
                                    type={"number"}
                                    value={data?.minHeight}
                                    label={"Минимальная высота"}
                                    setCurrValues={setData}
                                    validationError={validationState?.minHeight}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"minDepth"}
                                    type={"number"}
                                    value={data?.minDepth}
                                    label={"Минимальная глубна"}
                                    setCurrValues={setData}
                                    validationError={validationState?.minDepth}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"maxWidth"}
                                    type={"number"}
                                    value={data?.maxWidth}
                                    label={"Максимальная ширина"}
                                    setCurrValues={setData}
                                    validationError={validationState?.maxWidth}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"maxHeight"}
                                    type={"number"}
                                    value={data?.maxHeight}
                                    label={"Максимальная высота"}
                                    setCurrValues={setData}
                                    validationError={validationState?.maxHeight}
                                    setValidationState={setValidationState}
                                />
                                <TextFieldValidation
                                    name={"maxDepth"}
                                    type={"number"}
                                    value={data?.maxDepth}
                                    label={"Максимальная глубна"}
                                    setCurrValues={setData}
                                    validationError={validationState?.maxDepth}
                                    setValidationState={setValidationState}
                                />
                            </Box>
                            <Box sx={{
                                width: "400px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between"
                            }}>
                                <Box>
                                    <TextFieldValidation
                                        name={"patternW"}
                                        type={"text"}
                                        value={data?.patternW}
                                        label={"Паттерн ширины"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    <TextFieldValidation
                                        name={"patternD"}
                                        type={"text"}
                                        value={data?.patternD}
                                        label={"Паттерн глубины"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                    <TextFieldValidation
                                        name={"patternH"}
                                        type={"text"}
                                        value={data?.patternH}
                                        label={"Паттерн высоты"}
                                        setCurrValues={setData}
                                        required={false}
                                    />
                                </Box>
                                <Box sx={{
                                    width: 400,
                                    paddingTop: "20px",
                                    display: "flex",
                                    justifyContent: data ? "flex-end" : "flex-start"
                                }}>
                                    <ButtonAdd loading={loading} text={"Применить"} onClick={handleValidationData}/>
                                </Box>
                            </Box>

                        </Box> : tab === 2 ? <ComponentPatternsWithFilter
                            data={patterns}
                            setData={setPatterns}
                            handleModalAlert={handleModalAlert}
                            tableOptions={tableOptions}
                            tableOptionsHandle={tableOptionsHandle}
                            moduleId={data.id}
                            moduleName={moduleName}/> : tab === 3 ?
                            <ComponentDetailWithFilter
                                data={details}
                                tableOptions={tableOptions}
                                tableOptionsHandle={tableOptionsHandle}
                                setData={setDetailsFromTable}
                                handleModalAlert={handleModalAlert}
                                isColumnMaterial={false}
                                isColumnOrder={false}
                                isDetailModel={true}
                                isButtonAddDetail={false}
                                expanded={false}
                                viewingAvailable={true}
                                composition={true}
                            /> : tab === 5 ?
                                <ComponentFittingsWithFilter
                                    data={data.fittings}
                                    setData={setFittings}
                                    tableOptions={tableOptions}
                                    tableOptionsHandle={tableOptionsHandle}
                                    handleModalAlert={handleModalAlert}
                                    moduleId={data.id}
                                /> : tab === 4 ?
                                    <ComponentModulesWithFilter
                                        moduleId={data.id}
                                        moduleName={moduleName}
                                        compactEmbeddedModules
                                        embeddedModulesTableWidth={tabBarWidth}
                                        handleModalAlert={handleModalAlert}
                                        tableOptions={tableOptions}
                                        tableOptionsHandle={tableOptionsHandle}
                                        data={data.dependModules}
                                        setData={setDependModules}/> :
                                    tab === 6 ?
                                        <ComponentVariablesWithFilter
                                            data={variables}
                                            setData={setVariables}
                                            enableEditing={true}
                                            tableOptions={tableOptions}
                                            tableOptionsHandle={tableOptionsHandle}
                                            moduleId={data.id}
                                        /> :
                                        tab === 7 ?
                                            <DependentModuleCompositionsTable
                                                data={dependentModuleCompositions}
                                                setData={setDependentModuleCompositions}
                                                compositionId={pickKitchenCompositionId(data)}
                                                moduleCompositionId={data.id}
                                                handleModalAlert={handleModalAlert}
                                            /> :
                                            tab === 8 ?
                                                <Module3DView
                                                    moduleId={data.id}
                                                    moduleName={moduleName}
                                                    details={details}
                                                    detailsLoading={detailsLoading}
                                                    dependModules={data.dependModules}
                                                    onPacedDetailChange={setPacedDetailModuleByKey}
                                                    onPacedDependModuleChange={setPacedDependModuleByKey}
                                                    onDetailsReload={setDetailsFromTable}
                                                    moduleWidth={data?.width}
                                                    moduleHeight={data?.height}
                                                    moduleDepth={data?.depth}
                                                    embeddedSceneRefreshKey={embeddedSceneRefreshKey}
                                                /> :
                                                tab === PACED_MODULE_TAB ?
                                                    data.pacedModule == null ?
                                                        <Typography sx={{fontSize: "16px", color: "text.secondary"}}>
                                                            Данные о размещении отсутствуют
                                                        </Typography> :
                                                        <PacedModulePlacementPanel
                                                            pacedModule={data.pacedModule}
                                                            onPacedModuleChange={setPacedModule}
                                                            handleModalAlert={handleModalAlert}
                                                            tabStoragePath={tabStoragePath}
                                                        /> :
                                                null}
                    </>}
            </Box>
            <ModalAlert
                data={alertData}
                onClose={handleCloseAlert}/>
        </Box>
    )
}
export default ModulesItem